"use strict";

import Globals from "../Globals.js";
import PageCommon from "./PageCommon.js";
import Playlists from "./Playlists/Playlists.js";

export default class SearchManager extends PageCommon {
    constructor() {
        super();
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("SearchManager - constructor");
        this.tracks = [];
        this.playlists = [];
        this.userManager = null;
        this.filters = null;
        this.pageName = "";

        this.dataStructure = {};

        this.searchModeActive = false;
        this.currentSearch = "";
        this.keywords = [];
        this.searchResults = [];
        this.searchPlaylistResults = [];
        this.tagsList = [];
        this.tagsDivider = "&q[]=";
        this.categoriesList = [];
        this.categoriesDivider = "&filters[]=";
        this.enterTyped = false;
    }
    init({ pageName, dataStructure, userManager }) {
        super.init();
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("SearchManager - init");
        this.dataStructure = dataStructure;
        this.tracks = dataStructure.tracks;
        this.playlists = dataStructure.playlists;
        this.filters = dataStructure.filters;
        this.userManager = userManager;
        this.pageName = pageName;
        this.searchSetup();
        window.localStorage.setItem("search_tags", "");
        window.localStorage.setItem("search_categories", "");
        this.setupSavedSearch();
        Globals.searchManager = this;
    }

    setupSavedSearch() {
        const urlParams = this.getUrlParams();
        if (!urlParams.get("kw") && (window.location.pathname.indexOf("/find-music") === 0 || window.location.pathname.indexOf("/match-video") === 0)) {
            const savedTags = window.sessionStorage.getItem("search_tags");
            const savedCategories = window.sessionStorage.getItem("search_categories");
            if (savedTags || savedCategories) {
                let stringSearch = [];
                if (savedTags) stringSearch.push(savedTags);
                if (savedCategories) stringSearch.push(savedCategories);
                this.searchTracks(stringSearch.join(","), "tags");
            }
        }
    }

    getKeywords(search) {
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("SearchManager - Fetching Keywords");
        fetch(Globals.WS_URL +"?mode=KEYWORDS&q=" + window.encodeURIComponent(search))
            .then(this.handleResponse)
            .then((result) => {
                if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("SearchManager - Fetch Keywords OK");
                this.keywords = result.data.keywords;
                this.emitEvent("keywords_ready");
            })
            .catch((error) => {
                Globals.SHOW_ALL_CONSOLE_LOG && console.log({ message: error.message });
                jQuery(".js-critical-error").show();
            });
    }

    searchTracks(search, type) {
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("SearchManager - Searching Tracks");
        document.querySelector("#sideMenu").style.display = "";
        document.querySelector(".keywords-list-container").classList.remove("active");
        this.createContentWrapper();
        const urlParams = this.getUrlParams();
        let query = "";
        if (search) {
            let queryQ = "";
            let queryFilters = "";
            search.split(",").map((tag) => {
                const encodedTag = window.encodeURIComponent(window.decodeURIComponent(tag)).replace(/%20/g, " ");
                if (type === "tags") {
                    queryQ += "&q[]=" + encodedTag;
                } else if (type === "filters") {
                    queryFilters += "&filters[]=" + encodedTag;
                }
                this.createKeywordSearched(encodedTag, "tag");
            });
            query = `${queryQ}${queryFilters}`;
        } else {
            query = `${this.categoriesDivider}${this.categoriesList.join(this.categoriesDivider)}${this.tagsDivider}${this.tagsList.join(this.tagsDivider)}`;
        }
        if (document.querySelector(".sync-tool").style.display === "none") {
            history.pushState(history.state, document.title, `/find-music?kw=${this.tagsList.concat(this.categoriesList).join(",")}`);
        } else {
            history.pushState(history.state, document.title, `/match-video?kw=${this.tagsList.concat(this.categoriesList).join(",")}`);
        }
        if (this.tagsList.length > 0 || this.categoriesList.length > 0) {
            document.querySelector(".fm-searchbar .reset").style.display = "";
        }
        window.localStorage.setItem("search_tags", this.tagsList);
        window.localStorage.setItem("search_categories", this.categoriesList);
        window.sessionStorage.setItem("search_tags", this.tagsList);
        window.sessionStorage.setItem("search_categories", this.categoriesList);
        fetch(Globals.WS_URL +"?mode=SEARCH" + query)
            .then(this.handleResponse)
            .then((result) => {
                if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("SearchManager - Search Tracks OK");
                this.searchResults = result.data.search;
                this.searchPlaylistResults = result.data.search_playlist;
                this.emitEvent("search_results_ready");
            })
            .catch((error) => {
                Globals.SHOW_ALL_CONSOLE_LOG && console.log({ message: error.message });
                jQuery(".js-critical-error").show();
            });
        gtag(
            "event",
            (this.categoriesList.length > 0 ? "{c} " + this.categoriesList.join(", ") + " - " : "") + (this.tagsList.length > 0 ? "{k} " + this.tagsList.join(", ") : ""),
            { event_category: "search", event_label: "Search" }
        );
    }

    createContentWrapper() {
        const content = document.querySelector("#contentWrapper");

        // if (!this.searchModeActive) {
        //     setTimeout(() => (content.textContent = ""), 100);

        //     const tracksListContainer = document.createElement("div");
        //     tracksListContainer.id = "tracksSection";
        //     tracksListContainer.className = "fm-section";

        //     const tracksList = document.createElement("div");
        //     tracksList.className = "tracks-list";
        //     tracksList.innerHTML = `<div class="js-preloader small"><div class="spinner"></div></div>`;

        //     setTimeout(() => content.append(tracksListContainer), 100);

        //     tracksListContainer.appendChild(tracksList);
        // } else {
        //     content.querySelector("#tracksSection .tracks-list").innerHTML = `<div class="js-preloader small"><div class="spinner"></div></div>`;
        // }

        document.querySelector("#tracksSection").style.display = "";
        document.querySelector("#tracksSection .fm-section-header").style.display = "";
        content.querySelector("#tracksSection .tracks-list").innerHTML = `<div class="js-preloader small"><div class="spinner"></div></div>`;

        this.resetAllSections();
    }

    searchCategory(name) {
        const index = this.categoriesList.indexOf(name);

        this.resetAllSections();

        if (index > -1) {
            this.removeKeyword(name, "filter");
        } else {
            this.handleKeywordSearched(name, "filter");
        }
    }

    searchSetup() {
        const searchbar = document.querySelector(".fm-searchbar");
        const searchbarInput = searchbar.querySelector("input");
        const keywordsContainer = document.querySelector(".keywords-list-container");
        setTimeout((keywordsContainer.scrollTop = 0), 100);
        let selectedDropdownItem = 0;
        let selectedItem = null;
        const _this = this;
        searchbarInput.addEventListener("keyup", (event) => {
            event.preventDefault();
            _this.currentSearch = event.target.value;
            const keyCode = _this.getKeyCode(event);
            if (keyCode === "Enter") {
                if (_this.currentSearch) {
                    _this.enterTyped = true;
                    if (selectedItem && selectedDropdownItem > -1) {
                        return _this.emitEvent("click", null, selectedItem);
                    } else {
                        return _this.handleKeywordSearched(_this.currentSearch, "tag");
                    }
                }
                return;
            } else if (keyCode === "ArrowUp" || keyCode === "ArrowDown") {
                const keywordsList = keywordsContainer.querySelectorAll(".keyword");
                if (keyCode === "ArrowUp" && selectedDropdownItem > 0) {
                    selectedDropdownItem--;
                } else if (keyCode === "ArrowDown" && selectedDropdownItem < Array.from(keywordsList).length - 1) {
                    selectedDropdownItem++;
                } else {
                    return;
                }
                Array.from(keywordsList).map((keyword, index) => {
                    if (keyword.classList.contains("active")) {
                        keyword.classList.remove("active");
                    }
                    if (index === selectedDropdownItem) {
                        keyword.classList.add("active");
                        searchbarInput.value = keyword.textContent;
                        selectedItem = keyword;
                        if (selectedItem.offsetTop > keywordsContainer.offsetHeight / 2) {
                            keywordsContainer.scrollTop = selectedItem.offsetTop - keywordsContainer.offsetHeight / 2;
                        }
                    }
                });
                return;
            } else {
                _this.enterTyped = false;
                selectedDropdownItem = -1;
                setTimeout((keywordsContainer.scrollTop = 0), 100);
            }
            if (keyCode === "ArrowUp" || keyCode === "ArrowDown" || keyCode === "ArrowLeft" || keyCode === "ArrowRight") {
                return;
            }
            return _this.getKeywords(event.target.value);
        });
        const clearButton = searchbar.querySelector(".reset button");
        clearButton.addEventListener("click", (event) => {
            _this.resetSearchList();
            if (!event.detail?.disableDefaultSearch) {
                return _this.searchTracks();
            }
        });
        if (searchbarInput.value !== "") {
            searchbar.querySelector(".reset").style.display = "";
            _this.getKeywords(searchbarInput.value);
        }
        document.addEventListener("keywords_ready", (event) => {
            if (!_this.enterTyped) {
                _this.showKeywordsList();
            }
        });
        document.addEventListener("search_results_ready", (event) => {
            _this.showSearchResults();
        });
    }

    hideKeywordList(event) {
        if (!event.target.classList.contains("keywords-list-container")) {
            const container = document.querySelector(".keywords-list-container");
            container.classList.remove("active");
        }
    }

    showKeywordsList() {
        const container = document.querySelector(".keywords-list-container");
        const list = container.querySelector(".keywords-list");

        list.textContent = "";
        if (this.currentSearch === "" || this.keywords.length === 0) {
            container.classList.remove("active");
        }
        if (this.keywords.length > 0) {
            container.classList.add("active");
            const modelId = "#model-keywords-list";
            const item = document.querySelector(`${modelId} .keyword`).cloneNode(true);
            this.keywords.map((keyword, index) => {
                const element = item.cloneNode(true);
                if (index === 0) {
                    element.classList.add("active");
                }
                element.textContent = keyword;
                const _this = this;
                element.addEventListener("click", (event) => {
                    _this.handleKeywordSearched(keyword, "tag");
                });
                list.appendChild(element);
            });
            setTimeout((container.scrollTop = 0), 100);
            document.body.removeEventListener("click", this.hideKeywordList);
            document.body.addEventListener("click", this.hideKeywordList);
        }
    }

    createKeywordSearched(keyword, prefix) {
        const _this = this;
        const container = document.querySelector(".keywords-list-container");
        const keywordsSelected = document.querySelector(".keywords-selected");
        const modelId = "#model-keywords-selected";
        const item = document.querySelector(`${modelId} .keyword-selected`).cloneNode(true);
        item.id = prefix + "-" + _this._normalizza_track_prop(window.decodeURIComponent(keyword));
        item.dataset.name = keyword;
        item.classList.add(prefix);
        item.querySelector(".keyword-name").textContent = window.decodeURIComponent(keyword);
        item.querySelector(".remove-btn").dataset.tag = prefix + "-" + _this._normalizza_track_prop(window.decodeURIComponent(keyword));

        item.querySelector(".remove-btn").addEventListener("click", (event) => {
            _this.removeKeyword(keyword, prefix);
        });

        if (prefix === "tag") {
            _this.tagsList.push(keyword.replace(/%20/g, " "));
            gtag("event", keyword, { event_category: "tag", event_label: "Tag" });
        } else {
            _this.categoriesList.push(keyword.replace(/%20/g, " "));
            gtag("event", keyword, { event_category: "category", event_label: "Category" });
        }

        keywordsSelected.appendChild(item);

        document.querySelector(".fm-searchbar input").setAttribute("placeholder", "Add keyword to refine your search");
        document.querySelector(".fm-searchbar input").value = "";
        container.classList.remove("active");
    }

    handleKeywordSearched(keyword, prefix) {
        const _this = this;
        const container = document.querySelector(".keywords-list-container");
        const list = container.querySelector(".keywords-list");

        this.createKeywordSearched(window.encodeURIComponent(keyword), prefix);

        list.textContent = "";

        return _this.searchTracks();
    }

    removeKeyword(keyword, prefix) {
        const _this = this;
        const tag = document.querySelector("#" + prefix + "-" + _this._normalizza_track_prop(window.decodeURIComponent(keyword)));
        if (prefix === "tag") {
            _this.tagsList.splice(_this.tagsList.indexOf(tag.dataset.name), 1);
        } else {
            _this.categoriesList.splice(_this.categoriesList.indexOf(tag.dataset.name), 1);
            _this.filters.totalSelected--;
        }

        if (_this.tagsList.length === 0 && _this.categoriesList.length === 0) {
            document.querySelector(".fm-searchbar input").setAttribute("placeholder", "Search by typing any keyword");
            const searchbar = document.querySelector(".fm-searchbar");
            searchbar.querySelector(".reset").style.cssText = ";display: none !important;";
        }

        tag.remove();

        const filtersMenuHeader = document.querySelector("#filtersMenu .fm-nav-header");
        Array.from(document.querySelectorAll("#filtersMenu .nav-item")).map((filter, index) => {
            let counter = filter.querySelectorAll("input:checked").length;
            Array.from(filter.querySelectorAll(".submenu-list .form-check-input")).map((item) => {
                if (item.dataset.name === tag.dataset.name && item.checked) {
                    item.checked = false;
                    counter--;
                    if (counter === 0) {
                        filtersMenuHeader.querySelector(".reset").style.cssText = ";display: none !important;";
                        item.closest(".nav-item").querySelector(".badge").textContent = "";
                    } else {
                        filtersMenuHeader.querySelector(".reset").style.cssText = ";display: flex;";
                        item.closest(".nav-item").querySelector(".badge").textContent = counter;
                    }
                    _this.filters.data[index].selected--;
                }
            });
        });

        return _this.searchTracks();
    }

    setupPageForSearchResults() {
        if (document.querySelector("#playlistsSection")) document.querySelector("#playlistsSection").style.display = "";
        if (document.querySelector("#artistsBlock")) document.querySelector("#artistsBlock").remove();
        if (document.querySelector("#producersBlock")) document.querySelector("#producersBlock").remove();
        if (document.querySelector("#albumsBlock")) document.querySelector("#albumsBlock").remove();
    }

    showSearchResults() {
        if (!this.searchModeActive) {
            this.searchModeActive = true;
            this.setupPageForSearchResults();
        }

        const playlistSection = document.querySelector("#playlistsSection");
        playlistSection.textContent = "";
        if (this.searchPlaylistResults.length > 0) {
            playlistSection.style.display = "";

            fetch(`${Globals.URL_FETCH_BLOCK}section-playlists-swiper.html`)
                .then((data) => data.text())
                .then((html) => {
                    playlistSection.innerHTML = html;

                    const playlistItems = this.searchPlaylistResults.reduce((total, id) => {
                        const playlist = this.playlists.get({ id });
                        if (playlist) {
                            total.push(playlist.data);
                        }
                        return total;
                    }, []);
                    const playlists = new Playlists(playlistItems);
                    playlists.renderFirstpageList();
                    window.setSwiper();

                    const links = playlistSection.querySelectorAll(".swiper-slide a");
                    this.swapLinksToEvents(links, this.dataStructure, this.userManager);
                });
        } else {
            playlistSection.style.display = "none";
        }

        const tracksList = document.querySelector("#tracksSection .tracks-list");

        fetch(`${Globals.URL_FETCH_BLOCK}tracks-list.html`)
            .then((data) => data.text())
            .then((html) => {
                tracksList.innerHTML = html;

                const tracksListBody = tracksList.querySelector(".tracks-list-body");
                tracksListBody.textContent = "";

                if (this.searchResults) {
                    this.searchResults.map((id) => {
                        const track = this.tracks.get({ id });
                        if (track) {
                            tracksListBody.appendChild(this.tracks.getItem(track));
                        }
                    });
                } else {
                    this.tracks.renderFirstpageList();
                }

                this.emitEvent("search_result_rendered");
            });
    }

    resetSearchList(list) {
        const _this = this;
        const searchbar = document.querySelector(".fm-searchbar");
        searchbar.querySelector(".reset").style.cssText = ";display: none !important;";
        if (list === "tags") {
            Array.from(searchbar.querySelectorAll(".keywords-selected .keyword-selected.tag")).map((tag) => {
                tag.remove();
            });
            _this.tagsList = [];
        } else if (list === "filters") {
            Array.from(searchbar.querySelectorAll(".keywords-selected .keyword-selected.filter")).map((tag) => {
                tag.remove();
            });
            _this.categoriesList = [];
        } else {
            searchbar.querySelector(".keywords-selected").innerHTML = "";
            _this.tagsList = [];
            _this.categoriesList = [];
        }
        if (list !== "tags") {
            _this.filters.data.map((filter) => (filter.selected = 0));
            Array.from(document.querySelectorAll("#filtersMenu .submenu-list .form-check-input")).map((item) => {
                item.checked = false;
                item.closest(".nav-item").querySelector(".badge").textContent = "";
            });
            document.querySelector("#filtersMenu .fm-nav-header .reset").style.cssText = ";display: none !important;";
        }
        document.querySelector(".fm-searchbar input").setAttribute("placeholder", "Search by typing any keyword");
    }
}
